import Button, { ButtonProps } from '@anm/components/buttons/Button';
import styled, { css } from 'styled-components';

export const ButtonWrapper = styled(Button)<ButtonProps & { isActive: boolean }>`
  width: 150px;
  padding: 0;
  position: relative;
  background: #f4f6f7;
  color: #292a2b;
  font-size: 16px;
  line-height: 25px;
  border-radius: 20px;

  &:first-child {
    margin-right: 10px;
  }

  &:hover {
    color: #292a2b;
    background: #e9eef1;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background: #fff;
      &:hover {
        background: #fff;
      }
    `}
`;

export const Container = styled.div`
  padding: 8px;
  background: #f4f6f7;
  border-radius: 30px;
  display: flex;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 30px;
`;

export default Wrapper;
